import React from 'react';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { ProfileScreen } from './ProfileScreen';

/**
 * The Studio → Profile route (`promote/promoteProfile`). Every call is account-scoped. The key
 * starts a new screen for each artist, so the drafts of the old artist go.
 */
const ProfileViewComponent: React.FC = () => {
  const accountId = useAccountId();
  if (accountId === null) {
    return <LoadingView />;
  }
  return <ProfileScreen key={accountId} accountId={accountId} />;
};

export const ProfileView = TypedMemo(ProfileViewComponent);
